import { useState } from "react";
import { useMenuOpen } from "src/hooks/useMenuOpen";
import { menuIcon_First } from "../../../utils/menu/menuUtil";
import { FileWithLinesIcon } from "../common";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {}

export const BookmarkTopbarMenu = ({}: Props) => {

	const [expandSecondMenu, setExpandSecondMenu] = useState(false);

	const { openMenuFromBookmark } = useMenuOpen();
	const { bookmarkCdList } = useCommonCodeStore();
	

	const hoverTopbarMenuBgClass = "hover:bg-gray-400 hover:text-white ";
	const hoverTopbarMenuBorderClass = "hover:border-r-2 hover:border-blue-500";

	return <>
		<div className="relative min-w-[8%] h-full hover:bg-blue"
		onMouseEnter={() => setExpandSecondMenu(true)}
		onMouseLeave={() => setExpandSecondMenu(false)}>
			<p className={`w-full h-full font-semibold ${expandSecondMenu && "text-black"} text-white flex justify-start items-center pl-[15px] truncate`}>
				{menuIcon_First({menuCd: '$$$', menuNm: '즐겨찾기'})}
				{`즐겨찾기`}
			</p>
			{expandSecondMenu && <div className="w-[175px] min-w-[175px] absolute flex flex-col top-[40px] z-10 shadow-xl border-r border-gray-200 cursor-pointer ">
				{/* 2차 메뉴가 없는 경우 */}
				{bookmarkCdList.length === 0 && 
					<div className="w-full h-[40px] relative">
						<div className="w-full h-full relative">
							<p className={`h-full ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass} bg-white flex justify-start items-center pl-[15px]`}>
								비어있음	
							</p>
						</div>
					</div>
				}
				{/* 2차 메뉴가 있는 경우 */}
				{bookmarkCdList.map((bookmarkMenu) => <div key={bookmarkMenu.key} className="w-full h-[40px]">
					<div className="w-full h-full relative">
						<div className="w-full absolute top-0 flex flex-col z-20  shadow-xl">
							<div key={bookmarkMenu.key} className="w-[250px] min-w-[250px] h-[40px] relative"
								onClick={() => openMenuFromBookmark(bookmarkMenu)}>
								<p className={`h-full ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass} bg-white flex justify-start items-center pl-[15px]`}>
									<FileWithLinesIcon className="min-w-[35px] w-[35px] h-[20px]" style={{ color: '#1D4ED8' }} />
									{bookmarkMenu.name} 
									{bookmarkMenu.type === 'menu' && <span className="ml-1"></span>}
								</p>
							</div>
						</div>
					</div>
				</div>)}
			</div>}
		</div>
	</>
}